import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { getWAlert, WAlertState } from '@app/selectors/w-alert.selector';
import { WAlert } from '@app/models/components/w-alert.model';
import { ValidationUtil } from '@app/common/util/validation.util';
import { setWAlertStatus } from '@app/actions/w-alert.action';
import { ConvertUtil } from '@app/common/util/convert.util';
import { OrderMstModel } from '@app/models/myoffice/order/order-mst.model';
import { CartService } from '@app/services/shoppingmall/cart.service';
import { MyProgramConstant } from '@app/common/constant/my-program.constant';
import { Router } from '@angular/router';
import { AuthUtil } from '@app/common/util/auth.util';

declare const addEventListenerWAlert: any;
declare const showAlert: any;
declare const hideAlert: any;
declare const hideAllAlerts: any;

@Component({
  selector: 'w-alert',
  templateUrl: './w-alert.component.html',
  styleUrls: ['./w-alert.component.css']
})
export class WAlertComponent implements OnInit {

  wAlert$ = new Observable<WAlert>();
  wAlert: WAlert = {} as WAlert;

  listCart: OrderMstModel[] = {} as OrderMstModel[];

  confirmBtnText: string = "확인";
  cancelBtnText: string = "취소";
  icon: string = "successful";
  action: string = "";

  showBtnCart: boolean = false;
  pdtCd: string = "";
  quantity: number =1;
  cateNameOrg: string = "";

  constructor(
    private _wAlertStore: Store<WAlertState>,
    private _router: Router,
    private _cartSerivce: CartService) { 
    //
    this.wAlert$ = this._wAlertStore.select(getWAlert);
  }

  ngOnInit(): void {
    this.wAlert$.subscribe(res => {
      this.wAlert = res;
      this.initButtonText(res);

      if (ValidationUtil.isNotNullAndNotEmpty(res.icon)) {
        this.icon = ConvertUtil.convertToSring(res.icon);
        this.action = ConvertUtil.convertToString(res.action);
        if (typeof showAlert === "function") {
          setTimeout(() => showAlert(res.icon), 50);
        }
      } else {
        this.icon = "successful";
        this.action = "";
        if (typeof hideAllAlerts === "function") {
          hideAllAlerts(res.icon)
        }
      }
    });

    if (typeof addEventListenerWAlert === "function") {
      setTimeout(() => addEventListenerWAlert(), 50);
    }
  }

  handleOnClickConfirm(): void {
    if (ValidationUtil.isNotNullAndNotEmpty(this.wAlert.icon)) {
      this._wAlertStore.dispatch(setWAlertStatus({ status: { action: ConvertUtil.convertToSring(this.wAlert.action), isConfirm: true } }))
      if (typeof hideAlert === "function") {
        setTimeout(() => hideAlert(this.wAlert.icon), 50);
      }
    }
  }

  handleOnClickCancel(): void {
    if (ValidationUtil.isNotNullAndNotEmpty(this.wAlert.icon)) {
      if(this.action === 'add_cart_confirm'){
        if(AuthUtil.isLogined()) {
          this._router.navigateByUrl(MyProgramConstant.urlShopping + `/page-list-cart`);
        } else {
          this._router.navigateByUrl(MyProgramConstant.urlShopping + `/cart`);
        }
        
        if (typeof hideAlert === "function") {
          setTimeout(() => hideAlert(this.wAlert.icon), 50);
        }
      } else {
        this._wAlertStore.dispatch(setWAlertStatus({ status: { action: ConvertUtil.convertToSring(this.wAlert.action), isCancel: true } }))
        if (typeof hideAlert === "function") {
          setTimeout(() => hideAlert(this.wAlert.icon), 50);
        }
      }
      
    }
  }

  handleOnClickOuter(): void {
    if (ValidationUtil.isNotNullAndNotEmpty(this.wAlert.icon)) {
      this._wAlertStore.dispatch(setWAlertStatus({ status: { action: ConvertUtil.convertToSring(this.wAlert.action), isConfirm: false } }))
      if (typeof hideAlert === "function") {
        setTimeout(() => hideAlert(this.wAlert.icon), 50);
      }
    }
  }

  initButtonText(res: WAlert): void {
    if (ValidationUtil.isNotNullAndNotEmpty(res.confirmBtnText)) {
      // this.showBtnCart = false;
      this.confirmBtnText = ConvertUtil.convertToSring(res.confirmBtnText);
    } else {
      // this.showBtnCart = false;
      this.confirmBtnText = "확인";
    }

    if (ValidationUtil.isNotNullAndNotEmpty(res.cancelBtnText)) {
      // this.showBtnCart = false;
      this.cancelBtnText = ConvertUtil.convertToSring(res.cancelBtnText);
    } else {
      // this.showBtnCart = false;
      this.cancelBtnText = "취소";
    }

    if(ValidationUtil.isNotNullAndNotEmpty(res.listCart)){
      this.showBtnCart = true;
      this.listCart = res.listCart; 
    } else {
      this.showBtnCart = false;
    }

    if(ValidationUtil.isNotNullAndNotEmpty(res.pdtCd)){
      this.pdtCd = res.pdtCd;
    } else {
      this.pdtCd = '';
    }

    if(ValidationUtil.isNotNullAndNotEmpty(res.quantity)){
      this.quantity = res.quantity;
    } else {
      this.quantity = 1;
    }

    if(ValidationUtil.isNotNullAndNotEmpty(res.cateNameOrg)){
      this.cateNameOrg = res.cateNameOrg;
    } else {
      this.cateNameOrg = '';
    }
  }

  handleOnClickAddExistCart(): void {
    if (ValidationUtil.isNotNullAndNotEmpty(this.wAlert.icon)) {
      this._wAlertStore.dispatch(setWAlertStatus({ 
        status: { 
          action: ConvertUtil.convertToSring(this.wAlert.action), 
          isConfirm: true, 
          pdtCd: this.pdtCd, 
          quantity: this.quantity,
          cateNameOrg: this.cateNameOrg
        } 
      }));

      if (typeof hideAlert === "function") {
        setTimeout(() => hideAlert(this.wAlert.icon), 50);
      }
    }
  }

  handleOnClickAddNewCart(): void {
    if (ValidationUtil.isNotNullAndNotEmpty(this.wAlert.icon)) {
      this._cartSerivce.handleAddCartItemLogin(this.pdtCd, this.quantity, '');
      
      if (typeof hideAlert === "function") {
        setTimeout(() => hideAlert(this.wAlert.icon), 50);
      }
    }
  }
}
